import { createSelector } from 'reselect';

import { selectDataState } from '../selectors';
import { initialState } from './reducer';
let exports;

const makeSelectState = (key) => createSelector(selectDataState, (data) => data[key] || initialState);

const makeSelectData = (key) => createSelector(makeSelectState(key), (state) => state.data);

const makeSelectFilters = (key) => createSelector(makeSelectState(key), (state) => state.filters);

const createSelectors = (key) => ({
    selectState: exports.makeSelectState(key),
    selectData: exports.makeSelectData(key),
    selectFilters: exports.makeSelectFilters(key),
});

export default exports = {
    makeSelectState,
    makeSelectData,
    makeSelectFilters,
};

export { createSelectors };
